<template>
  <div>
    <h1>Bienvenido</h1>
    <h3>Sobre esta aplicación</h3>
    <p>Aplicación de prueba para poner en práctica el funcionamiento de Router Link de Vue.js, para aplicaciones SPA (Single Page Application).</p>
  </div>
</template>

<script>
export default {
  name: 'Welcome'
}
</script>

